module.exports = __webpack_public_path__ + "static/img/0.03d9300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/0.png
// module id = cTQp
// module chunks = 0